import { Button, Tabs } from "@rothoblaas/design-system";
import { FC, useState } from "react";
import useI18n from "../../hooks/useTranslations";
import Header from "../ui/Header";
import AdminPendingUsers from "./AdminPendingUsers";
import AdminUsersList from "./AdminUsersList";
import PendingUserModal from "./PendingUserModal";

// The stored users, and the pending ones: given roles and permissions by email before their first login.
const Users: FC = () => {
  const i18n = useI18n();
  const t = i18n.translation.users;
  const [isAdding, setIsAdding] = useState(false);

  return (
    <>
      <Header
        title={t.plural}
        path={{ display: t.all }}
        buttons={<Button onClick={() => setIsAdding(true)}>{t.add}</Button>}
      />

      <Tabs
        renderMode="lazy"
        urlParameter="tab"
        tabs={[{ title: t.plural }, { title: t.pending.plural }]}
        contents={[<AdminUsersList key="users" />, <AdminPendingUsers key="pending" />]}
      />

      {isAdding && <PendingUserModal onClose={() => setIsAdding(false)} />}
    </>
  );
};

export default Users;
